import { BodyProps } from 'constants/MultipleAcorddions';
import React, { memo, useCallback, useContext } from 'react';
import { ALICtx } from 'pages';
import { Flex, Box, Stack } from '@chakra-ui/react';
import { Button, Label, RadioInput, Unform, AddObservation } from 'components';

import { SubmitHandler } from '@unform/core';
import ALI from 'models/Forms/ALI';
import { checkPermission } from 'utils/authentication';

interface IProps extends BodyProps {}

const Item: React.FC<IProps> = ({ functionCallback, index, submit, completed }) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const ctx = useContext(ALICtx);

  const handleSubmit = useCallback<SubmitHandler<ALI>>(
    async data => {
      setLoading(true);
      if (submit) {
        const resp = await submit(data, '5 - Necessidade');
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [functionCallback, submit],
  );
  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform onSubmit={handleSubmit} initialData={ctx.data}>
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Label>É possível realizar a atividade com menos dados que o informado acima?</Label>

            <Box mt="8px">
              <RadioInput label="Sim" name="actitivyLessData" value={ctx.data?.actitivyLessData} />
              <AddObservation
                placeholder={'Observações sobre o tratamento de dados (opcional)'}
                obsValue={
                  ctx.data.jsonCustomObsObj ? ctx.data.jsonCustomObsObj.actitivyLessData : ''
                }
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      actitivyLessData: e.target.value,
                    },
                  }))
                }
              />
            </Box>
            <Label>
              É possível atingir o propósito da atividade utilizando dados menos intrusivos?
            </Label>

            <Box mt="8px">
              <RadioInput
                // isDisabled={!!ctx?.isDetails}
                label="Sim"
                name="actitivyPrivicyData"
                value={ctx.data?.actitivyPrivicyData}
              />
              <AddObservation
                // isDetail={ctx.isDetails}
                placeholder={'Observações sobre o tratamento de dados (opcional)'}
                obsValue={
                  ctx.data.jsonCustomObsObj ? ctx.data.jsonCustomObsObj.actitivyPrivicyData : ''
                }
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      actitivyPrivicyData: e.target.value,
                    },
                  }))
                }
              />
            </Box>
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Label>É possível realizar a atividade com menos dados que o informado acima?</Label>

            <Box mt="8px">
              <RadioInput
                isDisabled={completed}
                label="Sim"
                name="actitivyLessData"
                value={ctx.data?.actitivyLessData}
              />
              <AddObservation
                isDetail={completed}
                placeholder={'Observações sobre o tratamento de dados (opcional)'}
                obsValue={
                  ctx.data.jsonCustomObsObj ? ctx.data.jsonCustomObsObj.actitivyLessData : ''
                }
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      actitivyLessData: e.target.value,
                    },
                  }))
                }
              />
            </Box>
            <Label>
              É possível atingir o propósito da atividade utilizando dados menos intrusivos?
            </Label>

            <Box mt="8px">
              <RadioInput
                isDisabled={completed}
                label="Sim"
                name="actitivyPrivicyData"
                value={ctx.data?.actitivyPrivicyData}
              />
              <AddObservation
                isDetail={completed}
                placeholder={'Observações sobre o tratamento de dados (opcional)'}
                obsValue={
                  ctx.data.jsonCustomObsObj ? ctx.data.jsonCustomObsObj.actitivyPrivicyData : ''
                }
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      actitivyPrivicyData: e.target.value,
                    },
                  }))
                }
              />
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};
export const Necessity = memo(Item);
